
export default class OEMainMenuBtnAdapter {

    constructor() {
    }

    onConnect(oe, menu)   {
    }

    onRelease(oe, menu)   {
    }

    onPressed(activated, menu)   {
        return false;
    }

    isActive(menu)   {
        return false;
    }

    isEnabled(menu) {
        return false;
    }

    isFeatureAvailable(menu)    {
        return true;
    }

    isLicensingAccessible(menu)    {
        return true;
    }
}